// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_dropdownToggle_btn-primary__20qVy","container":"_dropdownToggle_container__14ClG","basic":"_dropdownToggle_basic__Q6M5b"};